import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { ThemeCustomizerService } from 'src/app/components/common/theme-customizer/theme-customizer.service';
import { PublicServiceService } from 'src/app/public-service.service';
import { OwlOptionsSliderConfig } from 'src/app/utils/Carousel-config';
import { getImgeUrl, getLanguages } from 'src/environments/environment';

@Component({
  selector: 'app-home-article',
  standalone: true,
  imports: [CarouselModule, RouterLink, CommonModule],
  templateUrl: './home-article.component.html',
  styleUrl: './home-article.component.scss'
})
export class HomeArticleComponent {

  isToggled = false;
  articles
  imageUrl = getImgeUrl()
  blogSlides: OwlOptions = OwlOptionsSliderConfig

  constructor(
    public themeService: ThemeCustomizerService,
    private publicService: PublicServiceService
  ) {
    this.themeService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });
    if (Number(localStorage.getItem("language")) == getLanguages().FA_IR) {
      this.blogSlides["rtl"] = true
    }
  }

  toggleTheme() {
    this.themeService.toggleTheme();
  }

  ngOnInit(): void { 
    this.getData()
  }

  getData() {
    this.publicService.getRecordHome(this.publicService.ARTICLE_URL).subscribe({
      next: (res) => {
        this.articles = res

      },
      error: (error) => {
        console.error("here goes the Unexpected error:", error);
      }
    })
  }
}
